import type { Walker } from "../../shared/avatars.ts";

/** Sprite sheets are 1254px square; each portrait is a circle [cx, cy, r]. */
export const SHEET_W = 1254;
const SLOTS: Record<"f" | "m", [number, number, number][]> = {
  f: [[170, 409, 145], [483, 398, 156], [793, 401, 153], [1090, 412, 143]],
  m: [[174, 908, 149], [483, 901, 157], [793, 904, 153], [1091, 913, 144]],
};
const CLASS_INDEX = { wanderer: 0, ranger: 1, warrior: 2, wizard: 3 } as const;

export interface Slot {
  url: string;
  cx: number;
  cy: number;
  r: number;
}

export function slotOf(w: Walker): Slot {
  const [cx, cy, r] = SLOTS[w.gender][CLASS_INDEX[w.cls]];
  return { url: `/sprites/${w.race}.png`, cx, cy, r };
}

/** CSS background crop for a circular portrait of `px` pixels. */
export function portraitStyle(w: Walker, px: number): React.CSSProperties {
  const o = slotOf(w);
  const sc = px / (2 * o.r);
  return {
    width: px,
    height: px,
    backgroundImage: `url(${o.url})`,
    backgroundSize: `${SHEET_W * sc}px ${SHEET_W * sc}px`,
    backgroundPosition: `${-(o.cx - o.r) * sc}px ${-(o.cy - o.r) * sc}px`,
  };
}
